import { API_CONFIG, getApiUrl } from '@/config/apiConfig';

export interface ClientVersion {
  version: number;
  /** ISO-8601 UTC instant for the version number. Null when the API omits a valid stamp. */
  updatedAt: string | null;
}

function readUpdatedAt(value: unknown): string | null {
  if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?Z$/.test(value)) {
    return null;
  }
  if (Number.isNaN(Date.parse(value))) return null;
  return value;
}

/** GET /api/kiosk/client-version. Null when the request fails or no version is published. */
export async function fetchClientVersion(): Promise<ClientVersion | null> {
  const response = await fetch(getApiUrl(API_CONFIG.ENDPOINTS.KIOSK.CLIENT_VERSION), {
    credentials: 'include',
    cache: 'no-store',
  });
  if (!response.ok) return null;
  const json = (await response.json()) as { data?: { version?: unknown; updatedAt?: unknown } };
  const version = json?.data?.version;
  if (typeof version !== 'number' || !Number.isSafeInteger(version) || version < 0) return null;
  return { version, updatedAt: readUpdatedAt(json.data?.updatedAt) };
}
